// imageValidationMixin.js
export const imageValidationMixin = {
 
  methods: {
    getComponentData() {
      if (this.customUserData && this.customUserData.picture && this.customUserData.picture !== '') {
      this.validateImagePath(this.customUserData.picture)
        .then((isValid) => {
          if (!isValid) {
            this.customUserData.picture = ''; 
          }
        });
    }
    else if (this.params.data.teacher_picture && this.params.data.teacher_picture !== '') {
      this.validateImagePath(this.params.data.teacher_picture).then((isValid) => {
        if (!isValid) {
          this.params.data.teacher_picture = ''; 
        }
      });
    }
    else {
      this.validateImagePath(this.params.data.student_picture).then((isValid) => {
        if (!isValid) {
          this.params.data.student_picture = '';
        }
      });
    }
    },
    validateImagePath(imagePath) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = imagePath;
        img.onload = () => {
          resolve(true);
        };
        img.onerror = () => {
          resolve(false);
        };
      });

    },
  },
  mounted() {
    
  },
};
